(function($, sd) {
    sd.Map = (function() {
        var mapLoaded = false;
        var options = {
            mapTab: "#tab-map",
            canvasCtrl: 'map-canvas',
            destAddressListCtrl: 'Addresses',
            originAddressCtrl: 'originAddress',
            getDirectionsButtonCtrl: 'btnGetDirections',
            textDirectionsPanelCtrl: 'text-directions-panel',
            highwaysCtrl: 'highways',
            tollsCtrl: 'tolls',
            ferriesCtrl: 'ferries',
            zoom: 14,
        };

        var geocoder = null;
        var init = function(args) {
            $.extend(options, args);
            
            wireUpTabChange();

            $("#" + options.destAddressListCtrl).on("change", function() {
                loadMap(true);
            });
            var activeTab = $(".tabs-nav li.is-active a");
            if ($(activeTab).attr('href') == options.mapTab) {
                loadMap();

            }

            $("#" + options.getDirectionsButtonCtrl).click(getDirections);
        };

        var wireUpTabChange = function() {
            $('a[data-toggle="tab"]').on('click', function(e) {
                if ($(e.target).attr('href') == options.mapTab) {
                    loadMap();

                };
            });
        };

        var loadGoogleMap = function (url) {

            if (navigator.userAgent.toLowerCase().includes('googlebot')) {
                return;
            }


            $.getScript(url, function() {
                geocoder = new google.maps.Geocoder();
                var address = $("#" + options.destAddressListCtrl).val();

                geocoder.geocode({ 'address': address }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {

                        var mapOptions = {
                            zoom: options.zoom,
                            zoomControl: true
                        };
                        var map = new google.maps.Map(document.getElementById(options.canvasCtrl), mapOptions);

                        map.setCenter(results[0].geometry.location);
                        var marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location,
                            html: $("#" + options.destAddressListCtrl + " option:selected").text()
                        });

                        var infowindow = new google.maps.InfoWindow({
                            content: "loading..."
                        });

                        google.maps.event.addListener(marker, 'click', function () {
                            infowindow.setContent(this.html);
                            infowindow.open(map, this);
                        });
                    }
                });
            });
        };

        var loadMap = function(addressChanged) {

            if (!addressChanged && mapLoaded) {
                return;
            }

            var isGoogleMapLoaded = $("#googlemap").attr("src") === "";

            if (!isGoogleMapLoaded) {
                var googleApiUrl = $('#googleMapApiValue').val();
                loadGoogleMap(googleApiUrl);
            }

            mapLoaded = true;
        };

        var getDirections = function() {

            var destAddress = $("#" + options.destAddressListCtrl).val();
            var originAddress = document.getElementById(options.originAddressCtrl).value.trim();

            if (originAddress == "") {
                alert('Please enter a start address');
                document.getElementById(options.originAddressCtrl).focus();
                return;
            }

            var directionsService = new google.maps.DirectionsService();
            var directionsDisplay = new google.maps.DirectionsRenderer();

            var mapOptions = {
                zoom: options.zoom,
                zoomControl: true
            };
            var map = new google.maps.Map(document.getElementById(options.canvasCtrl), mapOptions);

            $("#" + options.textDirectionsPanelCtrl).html("");
            directionsDisplay.setMap(map);
            directionsDisplay.setPanel(document.getElementById(options.textDirectionsPanelCtrl));

            var request = {
                origin: originAddress,
                destination: destAddress,
                travelMode: google.maps.DirectionsTravelMode.DRIVING,
                avoidFerries: $('#' + options.ferriesCtrl).is(":checked"),
                avoidHighways: $('#' + options.highwaysCtrl).is(":checked"),
                avoidTolls: $('#' + options.tollsCtrl).is(":checked"),
            };

            directionsService.route(request, function(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                } else {
                    alert('We could not recognise the origin address. Please correct it and try again.');
                }
            });
        };
        return {
            init: init,
            options: options
        };
    })();
})(jQuery, (window.SD || (window.SD = {})));

(function($) {
    $(document).ready(function () {
        SD.Map.init();
    });
})(jQuery);